<template>
  <div class="introduction">
    <div class="col-12 headerContent">
      <h3 v-html="program.howTheProgramWorksHeader"></h3>
      <div class="content-holder">
        <span v-html="program.howTheProgramWorksText" class="content"></span>
      </div>
      <a :href="program.programSummaryButtonLink" target="_blank" class="button" v-if="hasProgramLink" 
      v-html="`${program.programSummaryButtonLabel} <span class='visually-hidden'>&nbsp;link opens in new window</span>`"></a>
    </div>
  </div>
</template>
<script>
export default {
  name: "Summary",
  props: {
    program: Object,
  },
  computed: {
    hasProgramLink() {
      return this.program.programSummaryButtonLink && this.program.programSummaryButtonLabel;
    },
  },
};
</script>
<style lang="scss">
.row {
  .introTitle {
    padding: 50px 40px;
    .subHeaderText {
      font-size: 24px;
      line-height: 150%;
      margin: 30px 0 0 0;
      color: var(--primaryText);

      p {
        font-size: 24px;
        line-height: 150%;
        margin: 0;
      }
    }

    .headline {
      font-size: 50px;
      line-height: 150%;
      font-weight: 400;
      color: var(--secondaryText);
      margin: 0;

      p {
        color: inherit;
        font-size: inherit;
      }
    }
  }
}

.introduction {
  .button {
    @include round-btn();
    display: inline-block;
    margin-top: 10px;
  }
}

.introduction p,
.introduction h2 {
  font-weight: 400;
}

.headerContent {
  font-family: var(--micrositeTypeStyle);

  h3 {
    margin: 0 0 20px 0;
  }
  .content-holder {
    margin-bottom: 30px;
  }
  .content {
    font-size: 15px;
    color: var(--primaryText);    
  }
}

.introduction .headerContent {
  background-color: var(--backgroundAccent);
  padding: 40px;
}

@include media-breakpoint-down(md) {
  .introduction .introTitle,
  .headerContent {
    padding: 30px !important;
  }
}
</style>
